import { Signature } from '../../entities/Signature';
import { api } from '../api';

export const getSignature = async (id: string): Promise<Signature> => {
  const { data } = await api.get(`/signatures/${id}`);

  return data;
};
